import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logout-header',
  templateUrl: './logout-header.component.html',
  styleUrls: ['./logout-header.component.scss']
})
export class LogoutHeaderComponent implements OnInit {
  showLanguage = false;
  signInLanguageLabel = '';

  onToggleLanguage() {
    this.showLanguage = !this.showLanguage;
  }

  onToggleSignIn() {
    console.log('Sign-in clicked');
  }

  constructor() { }

  ngOnInit() {
  }

}
